import React from 'react';
import Link, { push } from 'gatsby-link';

class GetStartedButton extends React.Component {

    saveAndProceed = (value, link) => {

        if (this.props.index) {

            const valueLower = value.toLowerCase();

            localStorage.setItem('Generation', valueLower);
            push(link);

        } else {

            localStorage.setItem('About', value);
            push(link);

        }

    }

    _renderSubHeading = () => {

        if (!this.props.index) {

            return (
                <span className="block text-navy-dark">About</span>
            )

        }

    }

    render() {

        let buttonTextColour;
        let borderColour;
        let spacing;

        if(this.props.theme === 'orange') {
            buttonTextColour = 'text-orange';
            borderColour = 'border-orange';
        } else {
            buttonTextColour = 'text-blue';
            borderColour = 'border-blue';
        }

        if(this.props.left) {
            spacing = 'mr-8'
        } else {
            spacing = 'ml-8'
        }

        return (

            <button type="button" onClick={() => this.saveAndProceed(this.props.text, this.props.link)} title="Start About Me" className={'w-1/2 bg-white border-4 border-blue-transparent rounded-lg no-underline overflow-hidden hover:' + borderColour + ' ' + spacing }>

                <figure className="flex items-center justify-between">

                    <figcaption className="p-8 mr-8 text-center text-5xl leading-tight w-1/2">
                        {this._renderSubHeading()}
                        <span className={!this.props.index ? 'block ' + buttonTextColour : 'text-navy-dark'}>{this.props.text}</span>
                    </figcaption>

                    <div className="w-1/2">

                        <img src={this.props.img} className="block m-auto" />

                    </div>

                </figure>

            </button>

        )

    }

}

export default GetStartedButton;


// WEBPACK FOOTER //
// ./src/components/GetStartedButton.js